export const CONTENTS = 'Contents'
export const RESOURCES = 'Resources'
export const NOTES = 'Notes'
